import { createSelector } from 'reselect';
import { RedactionStatusesState } from './models';
import { RedactionStatusesStore, defaultState, namespace } from './store';

export const selectStore = (state: object): RedactionStatusesState =>
  (state as Partial<RedactionStatusesStore>)[namespace] || defaultState;

export const selectRedactionStatusSettings = createSelector(
  selectStore,
  (s) => s.redactionStatuses
);

export const selectRedactionStatusSdoIdsByStatus = createSelector(
  selectStore,
  (s): Record<string, string> => s.sdoIdsByStatus
);

export const selectIsFetchingRedactionStatuses = createSelector(
  selectStore,
  (s) => s.isFetchingStatuses
);

/**
 * True once a status fetch has succeeded this session. Consumers must gate on
 * this before trusting `customStatuses` — an empty list otherwise reads the
 * same whether the org has no custom statuses or the fetch simply failed.
 */
export const selectHasLoadedRedactionStatuses = createSelector(
  selectStore,
  (s) => s.hasLoadedStatuses
);

export const selectHasPersistedRedactionStatusRecords = createSelector(
  selectStore,
  (s) => s.hasPersistedStatusRecords
);

export const selectIsSavingRedactionStatuses = createSelector(
  selectStore,
  (s) => s.isSavingStatuses
);

export const selectRedactionCustomStatuses = createSelector(
  selectStore,
  (s) => s.customStatuses
);

export const selectEnabledRedactionCustomStatuses = createSelector(
  selectRedactionCustomStatuses,
  // Soft-deleted rows are never offered as options; use the unfiltered
  // selector above when resolving what an existing file's tag means.
  (customStatuses) =>
    customStatuses.filter((status) => status.enabled && !status.isDeleted)
);

export const selectIsStatusDrawerOpen = createSelector(
  selectStore,
  (s) => s.isStatusDrawerOpen
);

export const selectSelectedCustomStatus = createSelector(
  selectStore,
  (s) => s.selectedCustomStatus
);
